module.exports = __webpack_public_path__ + "static/media/pineapple.c37f6186.png";